enum EnumCompanyDocumentType {
	RegistrationDocument = 0,
	ExtractFromRegister = 1,
	CompanyCharter = 2,
	PowerOfAttorney = 3,
	DeclarationOfTrust = 4,
	RegistrationDocumentsOfNominalOwner = 5
}
export default EnumCompanyDocumentType
